<!-- https://www.figma.com/file/hZ14djvbx5qYuIJwSU7moW/%D0%AD%D0%BB%D0%B5%D0%BC%D0%B5%D0%BD%D1%82%D1%8B-%F0%9F%94%A5?node-id=797%3A77828&t=GQpEdPdrN33BPcYv-1 -->
<template>
  <div class="mobile-screenshots">
    <div class="mobile-screenshots__wrapper">
      <ArticlePicture
        v-for="item in items"
        :key="item.id"
        class="mobile-screenshots__item"
        :elem="item"
        :border-radius="0"
      />
    </div>
    <div
      v-if="caption && caption.length"
      class="mobile-screenshots__caption"
    >
      <TheContent
        v-for="content in caption"
        :key="content.id"
        :elem="content"
      />
    </div>
  </div>
</template>

<script lang="ts">
  import type { PropType } from 'vue';
  import ArticlePicture from '~/components/ArticlePicture.vue';
  import TheContent from '~/components/TheContent';
  import type { TContent } from '~/types/common';
  import type { IContentImage } from '~/types/components/ArticlePicture';
  import type { IContentMobileScreenshots } from '~/types/components/MobileScreenshots';

  export default defineNuxtComponent({
    name: 'MobileScreenshots',

    components: {
      ArticlePicture,
      TheContent,
    },

    props: {
      elem: {
        type: Object as PropType<IContentMobileScreenshots>,
        required: true,
      },
    },

    computed: {
      items(): IContentImage[] {
        return this.elem.attributes.items;
      },

      caption() {
        const captions: TContent[][] = this.items.map(
          (item: IContentImage) => item.attributes.parsed_caption,
        );
        if (captions.length === 2) {
          if (captions[0].length > 0 && captions[1].length > 0) {
            return captions[0];
          }

          if (captions[0].length > 0) {
            return captions[0];
          }

          if (captions[1].length > 0) {
            return captions[1];
          }
        }
        if (captions.length === 1) {
          return captions[0];
        }
        return null;
      },
    },
  });
</script>

<style lang="scss" scoped>
  .mobile-screenshots {
    &__wrapper {
      margin-left: -$spacing-4;
      margin-right: -$spacing-4;
      background: #f3f0f0;
      padding-top: $spacing-3;
      padding-bottom: $spacing-3;

      @include tablet {
        display: flex;
        justify-content: center;

        margin: 0;
        padding-top: $spacing-4;
        padding-bottom: $spacing-4;
        border-radius: 32px;
        overflow: hidden;
      }
    }

    &__item {
      max-width: 288px;
      margin: 0 auto;

      .article-picture__wrapp {
        border-radius: 0;
      }

      @include tablet {
        margin: 0;
        max-width: 224px;
        flex-basis: 224px;
      }

      &:not(:last-child) {
        margin-bottom: $spacing-3;

        @include tablet {
          margin-right: $spacing-4;
          margin-bottom: 0;
        }
      }
    }

    &__caption {
      font-family: $text-font--1;
      margin-top: $spacing-2;
      color: $text-color--1;
      @include tinyText;
      word-break: break-word;
      a {
        @include link-styles;
      }
    }
  }
</style>
